import * as React from "react";
import * as SeparatorPrimitive from "@radix-ui/react-separator";

import { cn } from "@/lib/utils";
import { cva, VariantProps } from "class-variance-authority";

const separatorVariants = cva(
  "shrink-0",
  {
    variants: {
      variant: {
        default: "bg-border",
        azure: "bg-azure/40",
        "muted-alt": "bg-muted-alt/30",
        aqua: "bg-aqua/80",
      },
      orientation: {
        horizontal: "w-full",
        vertical: "h-full",
      },
      size: {
        sm: "",
        md: "",
      },
    },
    compoundVariants: [
      { orientation: "horizontal", size: "sm", class: "h-[1px]" },
      { orientation: "horizontal", size: "md", class: "h-[2px]" },
      { orientation: "vertical", size: "sm", class: "w-[1px]" },
      { orientation: "vertical", size: "md", class: "w-[2px]" },
    ],
    defaultVariants: {
      orientation: "horizontal",
      size: "sm",
      variant: "default",
    },
  },
  // orientation === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
);

const Separator = React.forwardRef<
  React.ElementRef<typeof SeparatorPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root> &
    VariantProps<typeof separatorVariants>
>(
  (
    { className, decorative = true, variant, orientation, size, ...props },
    ref,
  ) => (
    <SeparatorPrimitive.Root
      ref={ref}
      decorative={decorative}
      orientation={orientation}
      className={cn(
        separatorVariants({ variant, orientation, size }),
        className,
      )}
      {...props}
    />
  ),
);
Separator.displayName = SeparatorPrimitive.Root.displayName;

export { Separator };
